module.exports = __webpack_public_path__ + "static/media/3-6.d26382b0.mp3";